import { OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(bottomSheetRef, data, translateService) {
        this.bottomSheetRef = bottomSheetRef;
        this.data = data;
        this.translateService = translateService;
        this.message = '';
    }
    ConfirmDialogComponent.prototype.ngOnInit = function () {
        this.message = this.data && this.data.message;
    };
    ConfirmDialogComponent.prototype.confirm = function () {
        this.bottomSheetRef.dismiss({
            message: 'Confirm',
            data: this.data
        });
    };
    ConfirmDialogComponent.prototype.cancel = function () {
        this.bottomSheetRef.dismiss({
            message: 'Cancel',
            data: this.data
        });
        event.preventDefault();
    };
    return ConfirmDialogComponent;
}());
export { ConfirmDialogComponent };
